// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_submissions.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.ProposalSubmissionFile
 */ export class ProposalSubmissionFile extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSubmissionFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSubmissionFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSubmissionFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSubmissionFile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 2;
   */ _define_property(this, "artifactVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSubmissionFile, "runtime", proto3);
_define_property(ProposalSubmissionFile, "typeName", "mono.datagateway.v1.ProposalSubmissionFile");
_define_property(ProposalSubmissionFile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Input pins are explicit. IDs, snapshot_json and recorded_at are server owned.
 *
 * @generated from message mono.datagateway.v1.ProposalSubmission
 */ export class ProposalSubmission extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string supersedes_id = 4;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: string pricing_version_id = 5;
   */ _define_property(this, "pricingVersionId", ""), /**
   * Explicit PROP-09 scenario version containing the selected labor/FTE model.
   *
   * @generated from field: string staffing_version_id = 6;
   */ _define_property(this, "staffingVersionId", ""), /**
   * @generated from field: string solicitation_version_id = 7;
   */ _define_property(this, "solicitationVersionId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalSubmissionFile files = 8;
   */ _define_property(this, "files", []), /**
   * @generated from field: repeated string section_version_ids = 9;
   */ _define_property(this, "sectionVersionIds", []), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 10;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: string submitted_timezone = 11;
   */ _define_property(this, "submittedTimezone", ""), /**
   * @generated from field: string submitted_by = 12;
   */ _define_property(this, "submittedBy", ""), /**
   * @generated from field: string method = 13;
   */ _define_property(this, "method", ""), /**
   * @generated from field: string recipient = 14;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: optional string receipt_reference = 15;
   */ _define_property(this, "receiptReference", void 0), /**
   * @generated from field: string notes = 16;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string recorded_by = 17;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 18;
   */ _define_property(this, "recordedAt", void 0), /**
   * Authoritative files/sections/pricing/staffing/solicitation, frozen at insert.
   *
   * @generated from field: string snapshot_json = 19;
   */ _define_property(this, "snapshotJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSubmission, "runtime", proto3);
_define_property(ProposalSubmission, "typeName", "mono.datagateway.v1.ProposalSubmission");
_define_property(ProposalSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pricing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "staffing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "solicitation_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "files",
            kind: "message",
            T: ProposalSubmissionFile,
            repeated: true
        },
        {
            no: 9,
            name: "section_version_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "submitted_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "submitted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "receipt_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordProposalSubmissionRequest
 */ export class RecordProposalSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordProposalSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordProposalSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordProposalSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordProposalSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: mono.datagateway.v1.ProposalSubmission submission = 4;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordProposalSubmissionRequest, "runtime", proto3);
_define_property(RecordProposalSubmissionRequest, "typeName", "mono.datagateway.v1.RecordProposalSubmissionRequest");
_define_property(RecordProposalSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission",
            kind: "message",
            T: ProposalSubmission
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordProposalSubmissionResponse
 */ export class RecordProposalSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordProposalSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordProposalSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordProposalSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordProposalSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalSubmission submission = 1;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordProposalSubmissionResponse, "runtime", proto3);
_define_property(RecordProposalSubmissionResponse, "typeName", "mono.datagateway.v1.RecordProposalSubmissionResponse");
_define_property(RecordProposalSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ProposalSubmission
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalSubmissionsRequest
 */ export class ListProposalSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalSubmissionsRequest, "runtime", proto3);
_define_property(ListProposalSubmissionsRequest, "typeName", "mono.datagateway.v1.ListProposalSubmissionsRequest");
_define_property(ListProposalSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalSubmissionsResponse
 */ export class ListProposalSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalSubmission submissions = 1;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalSubmissionsResponse, "runtime", proto3);
_define_property(ListProposalSubmissionsResponse, "typeName", "mono.datagateway.v1.ListProposalSubmissionsResponse");
_define_property(ListProposalSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: ProposalSubmission,
            repeated: true
        }
    ]));
